import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  colors: {
    primary: "#E6005D",
    secondary: "#2548b2",
    tertiary: "#2f0060",
    quarteriary: "#00013a",
    bg: "#01000e",
    text1: "white",
    text2: "#26e2de",
    link: " #27deff  ",
    linkVisited: "#a5e2ee ",
  },
  fontSize: {
    small: "18px",
    medium: "21px",
    large: "27px",
  },
  styles: {
    contentMaxWidth: "1520px"
  }
};

export default theme;
